
"use client";

import { createBrowserClient } from "@supabase/ssr";
import type { SupabaseClient } from "@supabase/supabase-js";

let _sb: SupabaseClient | null = null;

export function getSupabaseBrowser(): SupabaseClient {
  if (_sb) return _sb;

  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  if (!url || !key) {
    if (typeof window === "undefined") {
      // no SSR/pre-render
      // @ts-expect-error returning null only on server pre-eval
      return null;
    }
    throw new Error("Supabase env ausente no browser");
  }

  _sb = createBrowserClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
    },
  });
  return _sb;
}
